import React from 'react';
import './Styles/AppCenteredLayout.css';

/**
 * Component that will render its children at the very center
 * of the page. So centered both vertically as horizontally
 */
export const AppCenteredLayout = props => {
  return (
    <div className={`AppCentered ${props.styles}`}>
      <div className="AppCentered__HorizontalSpacer">
        <div className="AppCentered__VerticalSpacer">{props.children}</div>
      </div>
    </div>
  );
};
